// extracted by mini-css-extract-plugin
module.exports = {"approval-status-icon":"GeneralInfo_approval-status-icon__3P9Qp","green":"GeneralInfo_green__38jS8","red":"GeneralInfo_red__3tq0R"};